import { useEffect, useState } from 'react';
import type { ThemeColor } from '../types/theme';

const DARK_MODE_QUERY = '(prefers-color-scheme: dark)';

export function getSystemThemeColor(): ThemeColor {
  if (typeof window === 'undefined') {
    return 'light';
  }

  const mediaQuery = window.matchMedia?.(DARK_MODE_QUERY);
  if (!mediaQuery || typeof mediaQuery.matches !== 'boolean') {
    return 'light';
  }

  return mediaQuery.matches ? 'dark' : 'light';
}

export function useSystemThemeColor(): ThemeColor {
  const [systemColor, setSystemColor] = useState<ThemeColor>(getSystemThemeColor);

  useEffect(() => {
    const mediaQuery = window.matchMedia?.(DARK_MODE_QUERY);
    if (!mediaQuery) {
      return;
    }

    const handleChange = () => {
      setSystemColor(getSystemThemeColor());
    };

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', handleChange);
      return () => {
        mediaQuery.removeEventListener('change', handleChange);
      };
    }

    if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(handleChange);
      return () => {
        mediaQuery.removeListener(handleChange);
      };
    }
  }, []);

  return systemColor;
}
